import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { Dashboard, DashboardFilter } from '../../domain/dashboard/DashboardDomains';

export type DashboardAction =
  | 'CHANGE_TRANSACTIONS'
  | 'CHANGE_DASHBOARD'
  | 'CHANGE_LOADING'
  | 'CHANGE_DASHBOARD_RESPONSE'
  | 'CHANGE_EDIT_MODE'
  | 'CHANGE_DASHBOARD_FILTER'
  | 'CLEAR_DASHBOARD';

export const setDashboardTransactions = (payload: any[]) =>
  ({
    type: 'CHANGE_TRANSACTIONS',
    payload,
  }) as ReduxBaseAction<any[], DashboardAction>;

export const setDashboardResponse = (payload: any) =>
  ({
    type: 'CHANGE_DASHBOARD_RESPONSE',
    payload,
  }) as ReduxBaseAction<any, DashboardAction>;

export const changeDashboard = (payload: Dashboard) => {
  const normalizedPayload: Dashboard = {
    ...payload,
    collaborators: payload.collaborators ?? [],
    permission: payload.permission ?? 'Edit',
  };

  return {
    type: 'CHANGE_DASHBOARD',
    payload: normalizedPayload,
  } as ReduxBaseAction<Dashboard, DashboardAction>;
};

export const changeLoading = (payload: boolean) =>
  ({
    type: 'CHANGE_LOADING',
    payload,
  }) as ReduxBaseAction<boolean, DashboardAction>;

export const changeEditMode = (payload: boolean) =>
  ({
    type: 'CHANGE_EDIT_MODE',
    payload,
  }) as ReduxBaseAction<boolean, DashboardAction>;

export const setDashboardFilter = (payload: DashboardFilter) => ({
    type: 'CHANGE_DASHBOARD_FILTER',
    payload,
  }) as ReduxBaseAction<DashboardFilter, DashboardAction>;

export const clearDashboard = () =>
  ({
    type: 'CLEAR_DASHBOARD',
  }) as ReduxBaseAction<DashboardAction>;
